import React from 'react';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import { isAfter } from 'date-fns';
import { coerceToDate } from '@common/paymentsUtils/dateUtils';
import { Alert, Box, FormField, FormHelp, Label, Select } from '@zillow/constellation-10';
import dropdownBuilder from '../dropdownBuilder';
import PontoonConstants from '@common/constants/PontoonExceptionConstants';

interface Props {
  label: string;
  startPage?: string;
  dueDate: string;
  today?: Date;
  selectedDate: string;
  changeSelectedDate: (selectedDate: string) => void;
  fromDashboard: boolean;
}

class RecurringSchedulingPage extends React.Component<Props> {
  changeSelectedDate = (e) => {
    const value = e.target.value;
    this.props.changeSelectedDate(value);
  };

  isLatePayment = () => {
    const { dueDate, selectedDate } = this.props;
    const left = coerceToDate(selectedDate);
    const right = coerceToDate(dueDate);
    return !!left && !!right && isAfter(left, right);
  };

  renderLastDayOfMonthHelp = () => {
    const { selectedDate } = this.props;
    const selectedDateAsNumber = Number(
      formatDate(selectedDate, 'd', PontoonConstants.RENTER_HUB.PAYMENTS_SETTINGS.RENT_PAYMENT.DUE_DATE),
    );
    const showLastDayOfMonthText = selectedDateAsNumber > 28 && selectedDateAsNumber < 31;
    return showLastDayOfMonthText ? (
      <FormHelp>
        We’ll withdraw the rent on the last day of any month with fewer than {selectedDateAsNumber} days.
      </FormHelp>
    ) : undefined;
  };

  render() {
    const { label, dueDate, selectedDate, today } = this.props;
    const parsedDueDate = coerceToDate(dueDate) ?? new Date(dueDate as any);
    return (
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        <FormField
          css={{ width: '100%' }}
          label={<Label size="lg">{label}</Label>}
          control={
            <Select
              data-id="selectedDate"
              value={selectedDate}
              onChange={this.changeSelectedDate}
              css={{ width: '100%' }}
            >
              {dropdownBuilder(parsedDueDate, today)}
            </Select>
          }
          description={this.renderLastDayOfMonthHelp()}
        />
        {this.isLatePayment() && (
          <Alert tone="warning">
            Your chosen date is after the due date, so your rent could be considered late. Please contact your landlord
            in advance.
          </Alert>
        )}
        <Alert tone="info">
          We’ll email you a reminder 5 days before your payment is due each month. If this date falls on a weekend or
          holiday, we’ll send the rent 1 business day later.
        </Alert>
      </Box>
    );
  }
}

export default RecurringSchedulingPage;
